import { de } from '../i18n/de';
import { brandLogo } from '../lib/brand';
import { useColorScheme } from '../lib/colorScheme';

/**
 * Logo der Seite aus `assets/brand` – im hellen Modus `bright/logo`, im dunklen `dark/logo` (fehlt eines, gilt das andere). Ohne Logo
 * nichts. Rein schmückend (der Name steht daneben bzw. der Link trägt seine Beschriftung), daher ohne Alternativtext.
 */
export function BrandLogo({ className }: { className: string }) {
  const scheme = useColorScheme();
  const src = scheme === 'dark' ? (brandLogo.dark ?? brandLogo.light) : (brandLogo.light ?? brandLogo.dark);
  if (!src) return null;
  return (
    <picture className="brand-pic">
      <img className={className} src={src} alt="" draggable={false} data-testid="brand-logo" data-scheme={scheme} />
    </picture>
  );
}

/** Marke in Kopfzeilen (Kopfleiste, Startseite, Übersicht, Infoseiten): Logo und Name nebeneinander */
export function BrandLockup() {
  return (
    <>
      <BrandLogo className="brand-mark" />
      <span className="brand-name">{de.app.name}</span>
    </>
  );
}
